import { FilterType } from '@vk-hr-tek/core/filter';

export class NotificationsFiltersDto {
  filters?: FilterType;
}
